import { AssignUserPersistenceService } from 'src/app/shared/general/assigned-to/assign-to-user.service';
import { WorkshopJobService } from 'src/app/shared/services/workshop-job.service';
import { ViewWorkshopJobStoreService } from '../view-workshop-job-store.service';
import { Observable, filter, map, switchMap, take, tap } from 'rxjs';
import { Assignee } from 'src/app/shared/general/assigned-to/assigned-to-service-interface';
import { Injectable } from '@angular/core';

@Injectable()
export class AssignJobOwnerPersistenceService
  implements AssignUserPersistenceService
{
  private currentJobId$ = this.store.job$.pipe(
    map(({ id }) => id),
    filter(Boolean)
  );

  constructor(
    private workshopJobService: WorkshopJobService,
    private store: ViewWorkshopJobStoreService
  ) {}

  saveAssignee(assignee: Assignee): Observable<void> {
    return this.updateAssignee(assignee.value);
  }

  private updateAssignee(assignee: number | null) {
    return this.currentJobId$.pipe(
      take(1),
      switchMap((jobId: number) =>
        this.workshopJobService
          .update(jobId, { assigned_to: assignee })
          .pipe(map(() => {}))
      )
    );
  }
  removeAssignee() {
    return this.updateAssignee(null);
  }
}
